import { useMediaQuery } from 'react-responsive'

export default function useSmallScreen() {
  const isMobile = useMediaQuery({ query: '(max-width: 1100px)' })
  const isDesktop = useMediaQuery({ query: '(max-width: 1600px)' })
  return isMobile || isDesktop
    ? { desktop: isDesktop && !isMobile, mobile: isMobile }
    : { desktop: false, mobile: false }
}
